// extracted by mini-css-extract-plugin
module.exports = {"continer":"tip_box_personal__continer___2xsVi","header":"tip_box_personal__header___2fn-Y"};